export default __webpack_public_path__ + "static/media/afya_tech_logo.e43df54e.svg";